import React, { useEffect, useState } from "react";
import {
  Box,
  Button,
  Checkbox,
  FormControl,
  FormControlLabel,
  IconButton,
  InputLabel,
  MenuItem,
  Radio,
  Select,
  TextField,
  TextFieldProps,
  Typography,
} from "@mui/material";
import {
  CustomRadioProps,
  FeaturesCheckboxProps,
  FeatureDropDownProps,
  NumberInputProps,
  FlexInputLabelProps,
  InputListProps,
  AddFilterButtonProps,
} from "./FeatureInputTypes";
import { openPopup } from "../../../../../../stateManagement/actions/popupActions";
import RemoveOutlinedIcon from "@mui/icons-material/RemoveOutlined";
import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";
import AddOutlinedIcon from "@mui/icons-material/AddOutlined";

// Define styles for buttons
const buttonStyle = {
  width: "20px",
  height: "20px",
  minWidth: "unset",
  padding: "0",
  fontSize: "12px",
  lineHeight: "1",
};

const Input = (props: TextFieldProps) => {
  return (
    <TextField
      id="outlined-basic"
      size="small"
      sx={{
        minWidth: "32%",
        marginTop: "1rem",
        marginBottom: "1rem",
        borderRadius: "0%",
      }}
      defaultValue={""}
      variant="outlined"
      {...props}
    />
  );
};

export const InputList = (props: InputListProps) => {
  const [limiter, setLimiter] = useState(0);

  const handleListValueChange = (
    e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>,
    index: number
  ) => {
    const updatedList = props.values?.[props.configName]?.value;

    updatedList[index] = e.target?.value;
    props.setValues({
      ...props.values,
      [props.configName]: {
        ...props.values[props.configName],
        value: updatedList,
        isValueUpdated: true,
        domainType: props.domainType,
      },
    });
  };

  useEffect(() => {
    console.log("reseted value is",props.values[props.configName]?.value )
  }, [props.values[props.configName]]);
  const addField = () => {
    const actualLimit = props.limit;
    if (
      limiter >= actualLimit ||
      props.values?.[props.configName]?.value.length >= actualLimit
    ) {
      openPopup("Error", `Cannot set more than ${props.limit} fields`);

      return;
    }
    const updatedList = props.values?.[props.configName]?.value;
    updatedList.push("");

    setLimiter((prevLimiter) => prevLimiter + 1);

    props.setValues({
      ...props.values,
      [props.configName]: {
        ...props.values[props.configName],
        value: updatedList,
        isValueUpdated: true,
        domainType: props.domainType,
      },
    });
  };

  const deleteField = (index: number) => {
    const updatedList = props.values?.[props.configName]?.value;
    updatedList.splice(index, 1);
    setLimiter((prevLimiter) => prevLimiter - 1);

    props.setValues({
      ...props.values,
      [props.configName]: {
        ...props.values[props.configName],
        value: updatedList,
        isValueUpdated: true,
        domainType: props.domainType,
      },
    });
  };

  return (
    <>
      <div style={{ display: "flex", alignItems: "center" }}>
        <Typography color={"#606060"}>{props.question}</Typography>
        <IconButton
          onClick={addField}
          style={{ cursor: "pointer", color: "#23C6AF" }}
        >
          <AddCircleOutlineIcon></AddCircleOutlineIcon>
        </IconButton>
      </div>
      {props.defaultValue !== "" && (
        <>
          <div
            className="list_answer_container"
            style={{
              display: "flex",
              gap: "15px",
              marginBottom: "5px",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <Input
              value={props.defaultValue}
              onChange={(e) => {}}
              name={props.name}
              disabled={true}
              sx={{
                "& .MuiInputBase-input": {
                  color: "#909090",
                  borderRadius: "10px",
                },
              }}
            />
          </div>
        </>
      )}

      {props.values?.[props.configName]?.value.map(
        (element: string, index: number) => {
          return (
            <div
              key={index}
              className="list_answer_container"
              style={{
                display: "flex",
                gap: "15px",
                marginBottom: "5px",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <Input
                value={element}
                onChange={(e) => handleListValueChange(e, index)}
                name={props.name}
                sx={{
                  "& .MuiInputBase-input": {
                    color: "#909090",
                    borderRadius: "10px",
                  },
                }}
              />
              {props.values?.[props.configName]?.value !== "" && (
                <>
                  <IconButton
                    aria-label="delete"
                    size="small"
                    onClick={() => deleteField(index)}
                    sx={{
                      backgroundColor: "#ffedee",
                      color: "red",
                      "&:hover": {
                        backgroundColor: "#ffedee",
                        color: "red",
                        fontSize: "10px",
                      },
                    }}
                  >
                    <RemoveOutlinedIcon style={{ fontSize: "18px" }} />
                  </IconButton>
                </>
              )}
            </div>
          );
        }
      )}
    </>
  );
};

// Define styles for TextField
const textFieldStyle = {
  width: "4rem",
  mx: 2,
  "& input": {
    textAlign: "center",
    padding: "5px",
    height: "100%",
    boxSizing: "border-box",
  },
  "& .MuiOutlinedInput-root": {
    borderRadius: "4px",
    "& fieldset": {
      borderColor: "#ccc",
    },
    "&:hover fieldset": {
      borderColor: "#00C6B1",
    },
    "&.Mui-focused fieldset": {
      borderColor: "#00C6B1",
    },
  },
};

// Custom Radio component
export const CustomRadio: React.FC<CustomRadioProps> = ({
  label,
  value,
  checked,
  onChange,
  color = "#00C6B1",
  ...props
}) => (
  <FormControlLabel
    control={
      <Radio
        checked={checked}
        onChange={onChange}
        value={value}
        sx={{
          color,
          "&.Mui-checked": {
            color: "#00C6B1",
          },
        }}
        {...props}
      />
    }
    label={label}
    sx={{
      color:"black",
      fontSize:"13px"
    }}
  />
);

// Custom Checkbox component
export const FeaturesCheckbox: React.FC<FeaturesCheckboxProps> = (props) => (
  <span
    style={{
      fontSize: "1rem",
      display: "inline-flex",
      alignItems: "center",
      color: "#909090",
    }}
  >
    <Checkbox
      aria-label={props.label}
      {...props}
      defaultChecked={false}
      size="medium"
      sx={{
        color: "#909090",
        "&.Mui-checked": {
          color: "#00C6B1",
        },
      }}
    />
    <div style={{ color: "#909090" }}>{props.label}</div>
  </span>
);

// Custom Select dropdown component
export const FeatureDropDown: React.FC<FeatureDropDownProps> = ({
  label,
  selectLableId,
  options,
  placeholder,
  width,
  height,
  ...props
}) => (
  <FormControl
    margin="dense"
    sx={{
      minWidth: "clamp(200px, 30%, 400px)",
      width: width !== undefined ? width : "45%",
      display: "block",
    }}
  >
    <InputLabel
      id={selectLableId}
      sx={{
        transform: "none",
        transition: "none",
        top: 9,
        left: 15,
      }}
    >
      {label}
    </InputLabel>
    <Select
      labelId={selectLableId}
      color="primary"
      {...props}
      sx={{
        width: "100%",
        height: height !== undefined ? height : "100%",
      }}
        displayEmpty
       renderValue={(selected:any) => {
    if (selected === "") {
      return (
        <span style={{ color: "#909090" }}>
          {placeholder}
        </span>
      );
    }
    return selected;
  }}
  
    >
     
      {options?.map((option) => (
        <MenuItem
          key={typeof option === "object" ? option?.value : option}
          value={typeof option === "object" ? option?.value : option}
        >
          <span
            className="first_letter_capital"
            style={{ color: "#909090", fontWeight: 500 }}
          >
            {typeof option === "object" ? option.title : option}
          </span>
        </MenuItem>
      ))}
    </Select>
  </FormControl>
);

// Custom Number Input component
export const NumberInput: React.FC<NumberInputProps> = ({
  value,
  name,
  onChange,
  min = 0,
  max = 100,
  step = 1,
}) => {
  const handleIncrement = () => {
    if (value < max) {
      const newValue = value + step;
      console.log("Incrementing:", newValue); // Debugging
      const event = {
        target: {
          name: name,
          value: newValue.toString(),
        },
      } as React.ChangeEvent<HTMLInputElement>;
      onChange(event, newValue);
    }
  };

  const handleDecrement = () => {
    if (value > min) {
      const newValue = value - step;
      console.log("Decrementing:", newValue); // Debugging
      const event = {
        target: {
          name: name,
          value: newValue.toString(),
        },
      } as React.ChangeEvent<HTMLInputElement>;
      onChange(event, newValue);
    }
  };

  return (
    <Box display="flex" alignItems="center">
      <Button
        variant="outlined"
        onClick={handleDecrement}
        disabled={value <= min}
        style={buttonStyle}
      >
        -
      </Button>
      <TextField
        variant="outlined"
        value={value}
        name={name}
        onChange={(e) => {
          // Create a custom event object with the correct type
          const customEvent = {
            target: {
              name: name,
              value: e.target?.value,
            },
          } as React.ChangeEvent<HTMLInputElement>;
          onChange(customEvent, Number(e.target?.value));
        }}
        inputProps={{ min, max, step }}
        sx={textFieldStyle}
      />
      <Button
        variant="outlined"
        onClick={handleIncrement}
        disabled={value >= max}
        style={buttonStyle}
      >
        +
      </Button>
    </Box>
  );
};

export const FlexInputLabel: React.FC<FlexInputLabelProps> = ({
  label,
  value,
  name,
  onChange,
  placeholder,
  max,
  min,
  onValidationFailiure,
}) => {
  const [error, setErrorDisplay] = useState<boolean>(false);
  const handleValueChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (max && e.target?.value.length > max) {
      return;
    }
    if (min && e.target?.value.length < min) {
      onValidationFailiure && onValidationFailiure(true);
      setErrorDisplay(true);
    } else {
      onValidationFailiure && onValidationFailiure(false);
      setErrorDisplay(false);
    }
    onChange(e);
  };
  return (
    <>
      <Box
        sx={{
          width: "60%",
          display: "flex",
          gap: 4,
          alignItems: "center",
        }}
      >
        <InputLabel
          sx={{
            marginRight: "1rem",
            width: "auto",
            flexGrow: 1,
            // whiteSpace: "normal",
            overflow: "visible",
          }}
        >
          {label}
        </InputLabel>

        {/* <div className="textfield-container" style={{width:"100%"}}> */}
          <TextField
            variant="outlined"
            value={value}
            name={name}
            onChange={handleValueChange}
            placeholder={placeholder}
            sx={{
              marginY: "20px",
              borderRadius: "20px",
              width: "clamp(80px, 50%, 300px)",
              "& .MuiOutlinedInput-root": {
                padding: "0",
                "& .MuiOutlinedInput-notchedOutline": {
                  borderRadius: "8px",
                },
                "& input": {
                  paddingY: "8px",
                  textAlign: "center",
                },
              },
            }}
          />
         
        {/* </div> */}
      </Box>
      <div className="error-message" style={{display:"flex",justifyContent:"center"}}>
      {error && (
            <Typography
              style={{ color: "red", fontSize: "12px" }}
            >{`Label must be of at least ${min} characters.`}</Typography>
          )}
      </div>
      
    </>
  );
};

const AddFilterButton: React.FC<AddFilterButtonProps> = ({
  style = {},
  onClick,
}) => {
  return (
    <div
      onClick={onClick}
      style={{
        width: "45%",
        backgroundColor: "#F3FCFB",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        border: "1px dashed #5DC3B0",
        borderRadius: "5px",
        color: "#5DC3B0",
        cursor: "pointer",
        ...style,
      }}
    >
      <AddOutlinedIcon fontSize="large" />
    </div>
  );
};

export default AddFilterButton;
